import { Row, Space, Typography } from 'antd';
import UserAvatar from 'components/new-ui/base/avatar/UserAvatar';
import Button from 'components/new-ui/base/button/Button';
import { H2 } from 'components/new-ui/base/typography/styles';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { getDeclarationCountryLabel } from 'utils/getDeclarationCountryLabel';

type Props = {
    name: string;
    teamManagerInfo: {
        name: string;
        imageUrl: string;
    };
    market: DeclarationCountry;
    onEdit?: () => void;
};

const TeamDetails = ({ name, teamManagerInfo, market, onEdit }: Props) => {
    return (
        <div
            style={{
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
            }}
        >
            <Space direction="vertical" size={16}>
                <H2>Team Details</H2>
                <Space direction="vertical" size={24}>
                    <div>
                        <Typography style={{ marginBottom: 8 }}>Team Name</Typography>
                        <strong>
                            <Typography>{name}</Typography>
                        </strong>
                    </div>

                    <div>
                        <Typography style={{ marginBottom: 8 }}>Team Manager</Typography>
                        <Row align="middle">
                            {teamManagerInfo.imageUrl && teamManagerInfo.name && (
                                <UserAvatar
                                    style={{ marginRight: 8 }}
                                    size="small"
                                    userName={teamManagerInfo.name}
                                    src={teamManagerInfo.imageUrl}
                                />
                            )}
                            <strong>
                                <Typography>{teamManagerInfo.name ?? '-'}</Typography>
                            </strong>
                        </Row>
                    </div>

                    <div>
                        <Typography style={{ marginBottom: 8 }}>Market</Typography>
                        <strong>
                            <Typography>{getDeclarationCountryLabel(market)}</Typography>
                        </strong>
                    </div>
                </Space>
            </Space>
            {onEdit && <Button onClick={() => onEdit()}>Edit</Button>}
        </div>
    );
};

export default TeamDetails;
